import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
// import moment from "moment-timezone";

import { Space, Form, Input, Button, Card, message, Radio, Typography } from "antd";
import { LockOutlined } from "@ant-design/icons";

const { Title } = Typography;

const EditProfile = (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const cookies = new Cookies();
    const auth = cookies.get("authToken");
    const config = { headers: { "auth-token": auth } };
    const value = { userID: params.userID };

    const [form] = Form.useForm();

    const handleFinish = (values) => {
        // Check if passwords match if provided
        if (values.password && values.password !== values.password_confirmation) {
            message.error("รหัสผ่านและการยืนยันรหัสผ่านไม่ตรงกัน");
            return;
        }
        handleSubmit(values);
    };

    const handleSubmit = async (data) => {
        console.log("ข้อมูลใหม่:", data);
        await axios.put("/api/user/profile", data, config).then((response) => {
            message.success("ข้อมูลได้รับการบันทึกเรียบร้อยแล้ว!");
        });
    };

    useEffect(() => {
        const fetchUserDetail = async () => {
            await axios.get("/api/user/profile", config).then((response) => {
                console.log(response.data);
                form.setFieldsValue(response.data);
            });
        };
        fetchUserDetail();
    }, [config, form]);

    return (
        <>
            <Title level={3}>ใบประกาศทั้งหมด</Title>
            <Card>
                <Form form={form} layout="vertical" onFinish={handleFinish}>
                    <Form.Item
                        label="ยศ / ตำแหน่งต่างๆ เช่น พล.ต.ต. ศจ."
                        name="name_title"
                        // rules={[{ required: true, message: "กรุณากรอกยศ / ตำแหน่งต่างๆ เช่น พล.ต.ต. ศจ." }]}
                    >
                        <Input placeholder="กรุณากรอกยศ / ตำแหน่งต่างๆ เช่น พล.ต.ต. ศจ." />
                    </Form.Item>
                    <Form.Item name="name_prefix" label="คำนำหน้าชื่อ">
                        <Radio.Group>
                            <Radio value="นพ.">นพ.</Radio>
                            <Radio value="พญ.">พญ.</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item label="ชื่อ" name="firstname" rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}>
                        <Input placeholder="กรอกชื่อผู้ใช้" />
                    </Form.Item>
                    <Form.Item
                        label="นามสกุล"
                        name="lastname"
                        rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
                    >
                        <Input placeholder="กรุณากรอกนามสกุล" />
                    </Form.Item>
                    <Form.Item
                        label="หน่วยงานต้นสังกัด"
                        name="parent_organization"
                        rules={[{ required: true, message: "กรุณากรอกหน่วยงานต้นสังกัด" }]}
                    >
                        <Input placeholder="กรุณากรอกหน่วยงานต้นสังกัด" />
                    </Form.Item>
                    <Form.Item
                        label="ตำแหน่งที่ต้นสังกัด"
                        name="parent_organization_position"
                        rules={[{ required: true, message: "กรุณากรอกตำแหน่งที่ต้นสังกัด" }]}
                    >
                        <Input placeholder="กรุณากรอกตำแหน่งที่ต้นสังกัด" />
                    </Form.Item>
                    <Form.Item
                        label="อีเมล"
                        name="email"
                        rules={[{ required: true, type: "email", message: "กรุณากรอกอีเมลที่ถูกต้อง" }]}
                    >
                        <Input placeholder="example@email.com" disabled />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="รหัสผ่าน"
                        rules={[
                            {
                                min: 8,
                                message: "รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร",
                            },
                        ]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="กรอกเฉพาะเมื่อต้องการเปลี่ยนรหัสผ่าน" />
                    </Form.Item>

                    <Form.Item
                        name="password_confirmation"
                        label="ยืนยันรหัสผ่าน"
                        dependencies={["password"]}
                        rules={[
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue("password") === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error("รหัสผ่านและการยืนยันรหัสผ่านไม่ตรงกัน"));
                                },
                            }),
                        ]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="กรอกเฉพาะเมื่อต้องการเปลี่ยนรหัสผ่าน" />
                    </Form.Item>

                    {/* <Form.Item name="role" label="ประเภทผู้ใช้">
                        <Radio.Group>
                            <Radio value="teacher">ผู้สอน</Radio>
                            <Radio value="student">ผู้เรียน</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item name="is_active" label="สถานะ">
                        <Radio.Group>
                            <Radio.Button value={1}>active</Radio.Button>
                            <Radio.Button value={0}>inactive</Radio.Button>
                        </Radio.Group>
                    </Form.Item> */}
                    <Form.Item>
                        <Button type="primary" htmlType="submit" block>
                            บันทึกข้อมูล
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </>
    );
};

export default EditProfile;
